/* HC custom - "hide this row when it has nothing to show" for accordion rows.

   An accordion row can hold a block that renders nothing for the current
   product (an app block, or Size & Fit on a cooler) - the row's heading
   still shows and opens onto blank space. Liquid cannot see a block's
   output, so the check runs here: rows flagged data-hc-hide-empty start
   hidden (block stylesheet), each is inspected for real content, and the
   row is revealed when something is there. A MutationObserver keeps
   watching so content an app injects after load still reveals the row.

   Content a theme block draws on the server carries data-hc-has-content;
   the stylesheet already shows those rows, and this marks them filled.
   (The BF Size Charts fast path went with the app, 2026-10-01: the size
   charts are the theme's own hc-size-charts block now.) */

const SKIP = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT', 'LINK', 'META']);
const MEDIA = new Set([
  'IMG', 'SVG', 'PICTURE', 'VIDEO', 'AUDIO', 'IFRAME', 'CANVAS', 'TABLE',
  'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'A', 'DETAILS', 'DIALOG',
]);

function hasContent(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (SKIP.has(node.tagName)) return NodeFilter.FILTER_REJECT;
        return MEDIA.has(node.tagName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
      return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    },
  });
  return walker.nextNode() !== null;
}

function serverSaysFilled(root) {
  return root.querySelector('[data-hc-has-content]') !== null;
}

function evaluate(details) {
  const content = details.querySelector('.details-content');
  if (!content) return;
  const filled = serverSaysFilled(content) || hasContent(content);
  details.dataset.hcEmptyState = filled ? 'filled' : 'empty';
  return filled;
}

function watch(details) {
  if (details.dataset.hcEmptyWatched) return;
  details.dataset.hcEmptyWatched = '1';
  if (evaluate(details)) return;
  const content = details.querySelector('.details-content');
  const observer = new MutationObserver(() => {
    if (evaluate(details)) observer.disconnect();
  });
  observer.observe(content, { childList: true, subtree: true, characterData: true });
}

function scan(scope = document) {
  scope.querySelectorAll('details[data-hc-hide-empty]').forEach(watch);
}

scan();
// Theme editor re-renders sections and blocks in place.
document.addEventListener('shopify:section:load', (e) => scan(e.target));
document.addEventListener('shopify:block:select', (e) => scan(e.target));
